import type { JSX } from 'preact';
import { T, Icon } from '../../tokens';
import type { IconName } from '../../tokens';

export type AddKind = 'item' | 'equipment' | 'room' | 'property';

interface AddPickerSheetProps {
  readonly onClose: () => void;
  readonly onPick: (kind: AddKind) => void;
}

interface Choice {
  readonly id: AddKind;
  readonly icon: IconName;
  readonly title: string;
  readonly sub: string;
}

const CHOICES: readonly Choice[] = [
  { id: 'item', icon: 'item', title: 'Вещь', sub: 'дрель, паспорт, лыжи' },
  { id: 'equipment', icon: 'flame', title: 'Оборудование', sub: 'котёл, фильтр, кондей' },
  { id: 'room', icon: 'folder', title: 'Комната', sub: 'комната, гараж, кладовка' },
  { id: 'property', icon: 'home', title: 'Собственность', sub: 'квартира, дача, авто' },
];

export function AddPickerSheet({ onClose, onPick }: AddPickerSheetProps): JSX.Element {
  return (
    <div
      role="dialog"
      aria-modal="true"
      onClick={onClose}
      style={{
        position: 'absolute',
        inset: 0,
        background: 'rgba(31,27,22,0.4)',
        zIndex: 50,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: T.bg,
          borderRadius: '22px 22px 0 0',
          padding: '16px 16px calc(24px + env(safe-area-inset-bottom))',
          boxShadow: T.shadow3,
        }}
      >
        <div
          style={{
            width: 36,
            height: 4,
            background: T.borderStrong,
            borderRadius: 2,
            margin: '0 auto 14px',
          }}
        />
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: 4,
          }}
        >
          <div style={{ fontSize: 16, fontWeight: 700, color: T.ink }}>Что добавить?</div>
          <button
            type="button"
            onClick={onClose}
            aria-label="Закрыть"
            style={{ background: 'none', border: 'none', cursor: 'pointer', color: T.ink3 }}
          >
            <Icon name="close" size={20} />
          </button>
        </div>
        <div style={{ fontSize: 12.5, color: T.ink3, marginBottom: 14 }}>
          Или скажи голосом — ассистент сделает сам
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
          {CHOICES.map((c) => (
            <button
              key={c.id}
              type="button"
              onClick={() => onPick(c.id)}
              style={{
                padding: 14,
                background: T.surface,
                border: `1px solid ${T.border}`,
                borderRadius: 14,
                fontFamily: T.font,
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
                gap: 8,
                alignItems: 'flex-start',
                textAlign: 'left',
              }}
            >
              <Icon name={c.icon} size={22} color={T.ink2} />
              <div>
                <div style={{ fontSize: 14, fontWeight: 700, color: T.ink }}>{c.title}</div>
                <div style={{ fontSize: 11.5, color: T.ink3, marginTop: 3 }}>{c.sub}</div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
